import { useMutation, useQueryClient } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import { createContractPaymentModels, updateContractPaymentModels } from 'modules/settings/api';

export const useMutationContractPaymentModels = () => {
  const queryClient = useQueryClient();
  const { successToast, errorToast } = useCustomToast();
  const { mutateAsync: mutateCreate, isLoading: createMutationLoader } = useMutation(
    createContractPaymentModels,
    {
      onSuccess: () => successToast(),
      onError: () => errorToast(),
      onSettled: () => queryClient.refetchQueries(QUERY_KEYS.CONTRACT_PAYMENT_MODELS_ALL),
    },
  );

  const { mutateAsync: mutateUpdate, isLoading: updateMutationLoader } = useMutation(
    updateContractPaymentModels,
    {
      onSuccess: () => {
        successToast();
      },
      onError: () => errorToast(),
      onSettled: () => queryClient.refetchQueries(QUERY_KEYS.CONTRACT_PAYMENT_MODELS_ALL),
    },
  );

  return { mutateCreate, mutateUpdate, isLoading: createMutationLoader || updateMutationLoader };
};
